class CardSwatches extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll('input');
    this.card = this.closest('.card');
    this.images = this.card?.querySelectorAll('.card__media img') || [];
    this.selectedValue = this.card.querySelector('[data-selected-value]');
    this.cardForm = this.card.querySelector('card-form');
  }

  connectedCallback() {
    this.inputs.forEach(input =>
      input.addEventListener('change', () => this.updateCard())
    );

    this.updateCard();
  }

  updateCard() {
    const selectedValue = this.querySelector('input:checked')?.value;

    this.images.forEach(image => {
      const media = image.closest('.media');
      media?.classList.toggle('hidden', image.alt !== selectedValue);
    });

    this.selectedValue.textContent = selectedValue

    this.cardForm.updateUnavailableSizes(this.selectedValue.textContent);
  }
}

customElements.define('card-swatches', CardSwatches);
